import { AuthProvider } from '../../context/useAuthContext';
import { LayoutProvider } from '../../context/useLayoutContext';
import { ToastContainer } from 'react-toastify';
const AppProvidersWrapper = ({
  children
}) => {
  return <>      <AuthProvider>
        <LayoutProvider>
          {/* <NotificationProvider> */}
          {children}
          <ToastContainer theme="colored" />
          {/* </NotificationProvider> */}
        </LayoutProvider>
      </AuthProvider>
  </>;
};
export default AppProvidersWrapper;